"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuoteQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const UltraSwapService_1 = require("src/data/UltraSwapService");
const FormattedUltraQuoteResponse_1 = require("src/entity/FormattedUltraQuoteResponse");
const superstruct_1 = require("superstruct");
const useQuoteQuery = (params, shouldRefetch = true) => {
    const { amount } = params;
    return (0, react_query_1.useQuery)({
        queryKey: ['quote', params],
        queryFn: ({ signal }) => __awaiter(void 0, void 0, void 0, function* () {
            if (Number(amount) === 0) {
                return null;
            }
            try {
                const response = yield UltraSwapService_1.ultraSwapService.getQuote(params, signal);
                const quoteResponse = (0, superstruct_1.create)(response, FormattedUltraQuoteResponse_1.FormattedUltraQuoteResponse, 'conver FormattedUltraQuoteResponse Error');
                return {
                    quoteResponse,
                    original: response,
                };
            }
            catch (e) {
                if (e instanceof Response) {
                    const errorObj = yield e.json();
                    throw errorObj.error;
                }
                throw e;
            }
        }),
        refetchInterval: shouldRefetch ? 5000 : false,
        retry: 0,
        enabled: Number(amount) > 0,
        keepPreviousData: Number(amount) > 0,
        onError: (error) => {
            console.error('useQuoteQuery', error);
        },
    });
};
exports.useQuoteQuery = useQuoteQuery;
